import { render } from "./IconArrowRight3sticksType2.vue?vue&type=template&id=061b1311"
import script from "./IconArrowRight3sticksType2.vue?vue&type=script&lang=js"
export * from "./IconArrowRight3sticksType2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__